<template>
  <div>
    <div class="gl_title_bar marginBottom10">
      <div class="gl_tb_left">
        <span class="normaltitle">直播中</span>
      </div>
    </div>
    <div v-if="Livelist.startlive.length > 0">
      <div class="display_between marginTop20"
           v-for="(item, index) in Livelist.startlive"
           :key="index + '1'">
        <div class="pub_square"
             v-for="(itemx, indexx) in item"
             :key="indexx + '11'"
             @click="meetinginfo(itemx.live_id)">
          <div class="pubs_img">
            <img :src="Date.parse(itemx.start_time) < new Date() && Date.parse(itemx.end_time) > new Date() ? require('../../../assets/img/live/live.png')
                : Date.parse(itemx.end_time) < new Date() && !itemx.isPlayback ? require('../../../assets/img/live/over.png')
                    : Date.parse(itemx.end_time) < new Date() && itemx.isPlayback ? require('../../../assets/img/live/playback.png')
                        : Date.parse(itemx.start_time) > new Date() ? require('../../../assets/img/live/notice.png') : require('../../../assets/img/live/live.png')"
                 style="position: absolute; " />
            <img class="pubs_img"
                 :src="itemx.coverPictureUrl" />
          </div>
          <div class="pubs_body">
            <div class="pubs_title"
                 :title="itemx.title">{{ ellipsis(itemx.title, 17) }} {{ itemx.id }}</div>
          </div>
          <div class="display_between"
               v-if="itemx.org_name!=null && itemx.org_name!=''">
            <div class="pubs_tip pubs_body">
              <span style=""><img :src="itemx.orgLogoUrl"
                     width="18px" /></span>
              <span style="position: absolute;color: #000; margin-left: 10px;
                            line-height: 20px;"
                    :title="itemx.org_name">{{ ellipsis(itemx.org_name, 17) }}</span>
            </div>
          </div>
          <div class="display_between">
            <div class="pubs_tip pubs_body">
              <span>直播时间:</span>
              <span class="normalColor"> {{ formatTime(itemx.start_time, 'YYYY-MM-DD') }} 至 {{
                                formatTime(itemx.end_time, 'YYYY-MM-DD')
                            }}</span>
            </div>
          </div>
        </div>
        <div class="pub_square1"
             v-for="zhw in 3 - item.length"
             :key="zhw"></div>
      </div>
    </div>
    <div v-if="Livelist.liveall.length == 0">
      <ul class="NoneData">
        <p>
          <span>您还没有报名过任何直播！</span>
        </p>
      </ul>
    </div>
    <div class="gl_title_bar marginBottom10 marginTop20"
         v-if="Livelist.waitlive.length > 0">
      <div class="gl_tb_left">
        <span class="normaltitle">待开始</span>
      </div>
    </div>
    <div class="display_between marginTop20"
         v-for="(item, index) in Livelist.waitlive"
         :key="index + '2'">
      <div class="pub_square"
           v-for="(itemx, indexx) in item"
           :key="indexx + '21'"
           @click="meetinginfo(itemx.live_id)">
        <div class="pubs_img">
          <img :src="Date.parse(itemx.start_time) < new Date() && Date.parse(itemx.end_time) > new Date() ? require('../../../assets/img/live/live.png')
            : Date.parse(itemx.end_time) < new Date() && !itemx.isPlayback ? require('../../../assets/img/live/over.png')
                : Date.parse(itemx.end_time) < new Date() && itemx.isPlayback ? require('../../../assets/img/live/playback.png')
                    : Date.parse(itemx.start_time) > new Date() ? require('../../../assets/img/live/notice.png') : require('../../../assets/img/live/live.png')"
               style="position: absolute; " />
          <img class="pubs_img"
               :src="itemx.coverPictureUrl" />
        </div>
        <div class="pubs_body">
          <div class="pubs_title"
               :title="itemx.title">{{ ellipsis(itemx.title, 17) }}</div>
        </div>
        <div class="display_between"
             v-if="itemx.org_name!=null && itemx.org_name!=''">
          <div class="pubs_tip pubs_body">
            <span style=""><img :src="itemx.orgLogoUrl"
                   width="18px" /></span>
            <span style="position: absolute;color: #000; margin-left: 10px; 
                            line-height: 20px;"
                  :title="itemx.org_name">{{ ellipsis(itemx.org_name, 17) }}</span>
          </div>
        </div>
        <div class="display_between">
          <div class="pubs_tip pubs_body">
            <span>直播时间:</span>
            <span class="normalColor"> {{ formatTime(itemx.start_time, 'YYYY-MM-DD') }} 至 {{
                            formatTime(itemx.end_time, 'YYYY-MM-DD')
                        }}</span>
          </div>
        </div>

      </div>
      <div class="pub_square1"
           v-for="zhw in 3 - item.length"
           :key="zhw"></div>
    </div>
    <div class="gl_title_bar marginBottom10 marginTop20"
         v-if="Livelist.backlive.length > 0">
      <div class="gl_tb_left">
        <span class="normaltitle">回放中</span>
      </div>
    </div>
    <div class="display_between marginTop20"
         v-for="(item, index) in Livelist.backlive"
         :key="index + '4'">
      <div class="pub_square"
           v-for="(itemx, indexx) in item"
           :key="indexx + '31'"
           @click="meetinginfo(itemx.live_id)">
        <div class="pubs_img">
          <img :src="Date.parse(itemx.start_time) < new Date() && Date.parse(itemx.end_time) > new Date() ? require('../../../assets/img/live/live.png')
            : Date.parse(itemx.end_time) < new Date() && !itemx.isPlayback ? require('../../../assets/img/live/over.png')
                : Date.parse(itemx.end_time) < new Date() && itemx.isPlayback ? require('../../../assets/img/live/playback.png')
                    : Date.parse(itemx.start_time) > new Date() ? require('../../../assets/img/live/notice.png') : require('../../../assets/img/live/live.png')"
               style="position: absolute; " />
          <img class="pubs_img"
               :src="itemx.coverPictureUrl" />
        </div>
        <div class="pubs_body">
          <div class="pubs_title"
               :title="itemx.title">{{ ellipsis(itemx.title, 17) }}</div>
        </div>
        <div class="display_between"
             v-if="itemx.org_name!=null && itemx.org_name!=''">
          <div class="pubs_tip pubs_body">
            <span style=""><img :src="itemx.orgLogoUrl"
                   width="18px" /></span>
            <span style="position: absolute;color: #000; margin-left: 10px; 
                            line-height: 20px;"
                  :title="itemx.org_name">{{ ellipsis(itemx.org_name, 17) }}</span>
          </div>
        </div>
        <div class="display_between">
          <div class="pubs_tip pubs_body">
            <span>直播时间:</span>
            <span class="normalColor"> {{ formatTime(itemx.start_time, 'YYYY-MM-DD') }} 至 {{
                            formatTime(itemx.end_time, 'YYYY-MM-DD')
                        }}</span>
          </div>
        </div>
      </div>
      <div class="pub_square1"
           v-for="zhw in 3 - item.length"
           :key="zhw"></div>
    </div>
    <div class="gl_title_bar marginBottom10 marginTop20"
         v-if="Livelist.endlive.length > 0">
      <div class="gl_tb_left">
        <span class="normaltitle">已结束</span>
      </div>
    </div>
    <div class="display_between marginTop20"
         v-for="(item, index) in Livelist.endlive"
         :key="index + '3'">
      <div class="pub_square"
           v-for="(itemx, indexx) in item"
           :key="indexx + '31'"
           @click="meetinginfo(itemx.live_id)">
        <div class="pubs_img">
          <img :src="Date.parse(itemx.start_time) < new Date() && Date.parse(itemx.end_time) > new Date() ? require('../../../assets/img/live/live.png')
            : Date.parse(itemx.end_time) < new Date() && !itemx.isPlayback ? require('../../../assets/img/live/over.png')
                : Date.parse(itemx.end_time) < new Date() && itemx.isPlayback ? require('../../../assets/img/live/playback.png')
                    : Date.parse(itemx.start_time) > new Date() ? require('../../../assets/img/live/notice.png') : require('../../../assets/img/live/live.png')"
               style="position: absolute; " />
          <img class="pubs_img"
               :src="itemx.coverPictureUrl" />
        </div>
        <div class="pubs_body">
          <div class="pubs_title"
               :title="itemx.title">{{ ellipsis(itemx.title, 17) }}</div>
        </div>
        <div class="display_between"
             v-if="itemx.org_name!=null && itemx.org_name!=''">
          <div class="pubs_tip pubs_body">
            <span style=""><img :src="itemx.orgLogoUrl"
                   width="18px" /></span>
            <span style="position: absolute;color: #000; margin-left: 10px; 
                            line-height: 20px;"
                  :title="itemx.org_name">{{ ellipsis(itemx.org_name, 17) }}</span>
          </div>
        </div>
        <div class="display_between">
          <div class="pubs_tip pubs_body">
            <span>直播时间:</span>
            <span class="normalColor"> {{ formatTime(itemx.start_time, 'YYYY-MM-DD') }} 至 {{
                            formatTime(itemx.end_time, 'YYYY-MM-DD')
                        }}</span>
          </div>
        </div>
      </div>
      <div class="pub_square1"
           v-for="zhw in 3 - item.length"
           :key="zhw"></div>
    </div>
  </div>
</template>
<script>
import format from '@/assets/unit/unit.js';
import lodash from 'lodash';
export default {
  name: 'userMyMeeting',
  data () {
    return {
      trainmeetinglist: [], //全部会议
      AuthorId: 0,
      Livelist: {
        liveall: [],
        endlive: [],
        startlive: [],
        waitlive: [],
        backlive: []
      }
    };
  },
  created () {
    if (localStorage.getItem('ResData')) {
      this.AuthorId = JSON.parse(localStorage.getItem('ResData')).id;
    }
    this.getTrainMeetingList();
  },
  methods: {
    /*全国全科会议及培训*/
    getTrainMeetingList () {
      let _this = this;
      this.httphelper.post('/api/LiveTrainApi/GetUserSubLivie', {
        userId: this.AuthorId,
        type: 1,
        page: 1,
        limit: 99999
      })
        .then(res => {
          if (res.data.code == 200) {
            var _endlive = [];
            var _startlive = [];
            var _waitlive = [];
            var _backlive = [];
            _this.Livelist.liveall = res.data.data;

            res.data.data.forEach(item => {
              var theendtime = item.end_time;
              var endtime = new Date(Date.parse(theendtime.replace(/-/g, "/")));
              var thestarttime = item.start_time;
              var starttime = new Date(Date.parse(thestarttime.replace(/-/g, "/")));
              var curDate = new Date();
              if (endtime <= curDate) {
                if (item.isPlayback) {
                  _backlive.push(item)
                } else {
                  _endlive.push(item);
                }

              } else if (starttime <= curDate && endtime >= curDate) {
                _startlive.push(item);
              } else if (starttime > curDate) {
                _waitlive.push(item);
              }
            })
            _this.Livelist.endlive = lodash.chunk(_endlive, 3);
            _this.Livelist.startlive = lodash.chunk(_startlive, 3);
            _this.Livelist.waitlive = lodash.chunk(_waitlive, 3);
            _this.Livelist.backlive = lodash.chunk(_backlive, 3);
          }
        });
    },
    formatTime (datatime, timeformat) {
      return format(datatime, timeformat);
    },
    meetinginfo (mtgid) {
      var url = 'https://live.gp519.com/detail?id=' + mtgid
      window.open(url, '_blank');
    }
  }
};
</script>
<style>
.pubs_title {
    font-size: 16px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #000000;
    line-height: 20px;
    font-weight: bold;
    overflow: hidden;
    height: 20px;
    text-overflow: ellipsis;
    white-space: nowrap;
}

/* 块状列表 */
.pub_square {
    width: 300px;
    height: 280px;
    background: #ffffff;
    border-radius: 0px 0px 5px 5px;
    box-shadow: 0px 4px 8px 0px rgba(0, 0, 0, 0.04);
}

.pub_square1 {
    width: 300px;
    height: 280px;
    background: #ffffff;
    border-radius: 0px 0px 5px 5px;
    /* box-shadow: 0px 4px 8px 0px rgba(0, 0, 0, 0.04); */
}

.NoneData {
    padding: 40px;
    text-align: center;
    color: #999;
    font-size: 18px;
    letter-spacing: 1px;
}
</style>
